<template>

    <div class="page p-patients">
        <the-dashboard-heading>
            <h2>Pacjenci</h2>
            <v-btn type="white" :to="{ name: 'PatientAdd' }">Dodaj nowego pacjenta</v-btn>
        </the-dashboard-heading>

        <the-dashboard-content>
            <patient-list
                class="p-patients__table"
                :is-fetching="isFetching"
                v-model="patients.data">
            </patient-list>
        </the-dashboard-content>

        <v-pagination v-model="patients.last_page"></v-pagination>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import VPagination from 'Components/VPagination'

import VBtn from 'Components/VBtn'
import PatientList from 'Components/Patient/PatientList'

export default {

    name: 'ViewPatients',

    data() {
        return {
            isFetching: false
        }
    },

    computed: {
        ...mapGetters(['patients'])
    },

    watch: {
        '$route.query'() {
            this.isFetching = true
            store.dispatch('PATIENTS_FETCH', this.$route.query).then(() => {
                this.isFetching = false
            })
        }
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('PATIENTS_FETCH', to.query),
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },


    components: {
        TheDashboardHeading,
        TheDashboardContent,
        VPagination,
        VBtn,
        PatientList
    }

}

</script>


<style lang="scss">

.p-patients {
    &__table {
        width: 100%;
    }
}

</style>
